import { useDimensions } from '@/hooks/useDimensions';
import { useGetBreadName } from '@/hooks/useGetBreadName';
import { SortOrderType } from '@/service/type';
import { useLeftPanelDrawer } from '@/state/drawer-store';
import React, { useCallback, useRef, useState } from 'react';
import Search from '../../Search';
import { CloseFilledIcon } from '@/components/Icons';
import { cn } from '@/utils';
import { debounce } from 'lodash-es';

interface AudioListHeaderProps {
  setName: (val: string) => void;
  ifScrolledSomeDistance: boolean;
  order: SortOrderType;
  setOrder: (order: SortOrderType) => void;
  isHideOnMobile?: boolean;
}

export const AudioListHeader: React.FC<AudioListHeaderProps> = ({ setName, ifScrolledSomeDistance, order, setOrder, isHideOnMobile }) => {
  const [showInput, setShowInput] = useState(false);
  const searchInputRef = useRef<HTMLInputElement | null>(null);
  const { isMobileOrPad } = useDimensions();
  const { setIsDrawerShow: setIsLeftPanelShow } = useLeftPanelDrawer();
  const { firstPathName, lastPathName } = useGetBreadName();
  const handleSearch = useCallback(
    debounce((value: string) => {
      setName(value);
    }, 300),
    [setName],
  );
  if (isMobileOrPad) {
    return (
      <div
        className={cn(
          ' absolute left-0 top-0 w-full bg-jen-background-secondary z-20 overflow-hidden h-[136px] text-[64px] transition-all duration-500 leading-none flex flex-col justify-between  min-w-0',
          {
            'h-0 px-0 py-0 opacity-0': isHideOnMobile,
            'opacity-100 py-jen-spacing-16 px-jen-spacing-12': !isHideOnMobile,
          },
        )}
      >
        {showInput ? (
          <>
            <input
              ref={searchInputRef}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                handleSearch(e.target.value);
              }}
              onKeyDown={(e: React.KeyboardEvent<HTMLInputElement>) => {
                if (e.key === 'Escape') {
                  setShowInput(false);
                  setName('');
                }
              }}
              placeholder={'Search...'}
              className="tracking-[-3.84px] placeholder:text-jen-content-secondary text-jen-content-primary border-b  w-full  outline-none  bg-jen-background-secondary "
            ></input>
            <CloseButton
              onClick={() => {
                setShowInput(false);
                setName('');
              }}
            />
          </>
        ) : (
          <>
            <div className={cn('truncate', { 'text-[48px]': lastPathName.length > 10 })}>{lastPathName}</div>
            <Search
              onClickSearch={() => {
                setShowInput(true);
                setTimeout(() => {
                  searchInputRef?.current?.focus();
                });
              }}
              className="justify-normal"
              order={order}
              setOrder={(val) => {
                setOrder(val);
              }}
            />
          </>
        )}
      </div>
    );
  }
  return (
    <>
      {showInput ? (
        <>
          <div className="flex justify-between pt-jen-spacing-16 pl-[24px] pr-[24px] pb-jen-spacing-8 items-start">
            <div className="text-jen-size-heading-07 text-jen-mid-grey leading-4 ">SEARCH CATALOG</div>
            <CloseButton
              onClick={() => {
                setShowInput(false);
                setName('');
              }}
            />
          </div>
          <div className="z-10 w-full px-jen-spacing-24  absolute top-[52px] bg-jen-background-secondary">
            <input
              ref={searchInputRef}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                handleSearch(e.target.value);
              }}
              onKeyDown={(e: React.KeyboardEvent<HTMLInputElement>) => {
                if (e.key === 'Escape') {
                  setShowInput(false);
                  setName('');
                }
              }}
              placeholder={'Search...'}
              className="tracking-[-3.84px] placeholder:text-jen-content-secondary text-jen-content-primary border-b  w-full h-[96px] outline-none  bg-jen-background-secondary  text-[96px]"
            ></input>
          </div>
        </>
      ) : (
        <div className="flex justify-between pt-jen-spacing-16 pl-[24px] pr-[24px] pb-jen-spacing-8 items-start">
          <div className="text-jen-size-heading-07 text-jen-mid-grey leading-4 " onClick={() => isMobileOrPad && setIsLeftPanelShow(true)}>
            {firstPathName}/
            <span
              className={` transition-opacity text-jen-content-secondary duration-500 ${ifScrolledSomeDistance ? 'opacity-100' : 'opacity-0'}`}
            >
              {lastPathName}
            </span>
          </div>
          <div>
            <Search
              onClickSearch={() => {
                setShowInput(true);
                setTimeout(() => {
                  searchInputRef?.current?.focus();
                });
              }}
              order={order}
              setOrder={(val) => {
                setOrder(val);
              }}
            />
          </div>
        </div>
      )}

      <div
        className={cn(
          'tracking-[-3.84px] pl-[24px] w-full text-[72px] bg-jen-background-secondary leading-none lg:text-[96px] absolute top-[52px] transition-all duration-500 transform truncate z-[2]',
          {
            'opacity-0 -translate-y-4 pointer-events-none': ifScrolledSomeDistance,
            'opacity-100 translate-y-0': !ifScrolledSomeDistance,
          },
        )}
      >
        {lastPathName}
      </div>
    </>
  );
};

const CloseButton = ({ onClick }: { onClick: () => void }) => {
  return (
    <div onClick={onClick} className="w-[34px] h-[34px] cursor-pointer p-jen-spacing-4 bg-jen-border rounded-[4px]">
      <CloseFilledIcon fillOpacity={'#67666d'} />
    </div>
  );
};
